import React from 'react';

import sharedStyles from 'src/common/components/GridCard/_shared-styles.module.scss';

import { RecipeCardSource } from '~/src/common/components/GridCard/ProductCard/types';
import { GridCardFormat } from '~/src/common/components/GridCard/types';
import ImageObjectFit from '~/src/common/components/ImageObjectFit';
import Link from '~/src/common/components/Link';
import TypeTag from '~/src/common/components/Recipe/TypeTag/TypeTag';
import { Image, ImageParams, ImageTypeParams } from '~/src/common/typings/image';
import { RecipeType } from '~/src/common/typings/product';
import { getImageUrlFromFormat } from '~/src/common/utils/cloudinary';
import { useRecipeLink } from '~/src/screens/CatalogContent/ContentScreen/hooks/catalogContentLinks';

import gridStyles from '../GridCard.module.scss';

import styles from './RecipeCard.module.scss';

// Las params de taille/quolité dépendent du format
const PARAMS = {
  card_ratio: ImageParams.listingCard, // Classique en 290 de large
  square: ImageParams.listingCardLarge, // Carré, jusqu'à 500 de large
} satisfies Record<GridCardFormat, ImageTypeParams>;

interface Props {
  image?: Image;
  name: string;
  slug: string;
  tag: RecipeType;
  eventSource: string;
  source: RecipeCardSource;
  categoryName?: string;
  subcategory?: { id: string; name: string };
  recipeTypeId?: string;
  format?: GridCardFormat;
  onClick?: () => void;
}

const RecipeCard = ({
  name,
  image,
  tag,
  slug,
  categoryName,
  source,
  subcategory,
  recipeTypeId,
  eventSource,
  format = 'card_ratio',
  onClick,
}: Props) => {
  const imageUrl = getImageUrlFromFormat(image, format, PARAMS[format]);

  const { as, query } = useRecipeLink(slug, {
    category: categoryName,
    subcategory: subcategory?.name,
    recipeTypeId,
    eventSource,
    source,
  });

  return (
    <article
      className={gridStyles.container}
      style={{
        aspectRatio:
          format === 'square' ? sharedStyles['CARD_RATIO-square'] : sharedStyles['CARD_RATIO-card'],
      }}
      onClick={onClick}>
      {imageUrl ? (
        <ImageObjectFit
          src={imageUrl}
          objectFit="cover"
          objectPosition="center"
          alt={name}
          className={gridStyles.image}
        />
      ) : null}
      <div className={gridStyles.content}>
        <Link href={{ pathname: as, query }}>
          <div className={styles.topSectionContainer}>
            <div className={gridStyles.informationContainer}>
              <TypeTag recipeType={tag} />
              <div className={styles.productName}>{name}</div>
            </div>
          </div>
        </Link>
      </div>
    </article>
  );
};

export default React.memo(RecipeCard);
